import { z } from "zod";

export const boardAlertSchema = z.object({
  title: z.string().min(1, "Board Alert Title is required").max(255, "Title must be less than 255 characters"),
  description: z.string().min(1, "Board Alert Description is required").max(2000, "Description must be less than 2000 characters")
});

export type BoardAlertFormData = z.infer<typeof boardAlertSchema>;
